"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAtpClusterId = void 0;
var _fetching = require("@ori/fetching");
var _staticApiClientReact = require("@ori/static-api-client-react");
/**
 * Utility function for the client and the server to fetch ATP Cluster ID for a given tenant and current customer ID.
 * Allows aborting requests via custom AbortController.
 * Provides fallback for non-fatal errors.
 */
const getAtpClusterId = async ({
  abortController,
  client,
  tenant,
  customerId
}) => {
  const response = await (0, _staticApiClientReact.getTenantAtpClusters)(client, tenant, {
    customerId
  }, {
    signal: abortController?.signal,
    validateStatus: _fetching.validateStatus
  });
  return (0, _fetching.handleResponse)(response, {
    onError: () => undefined,
    onSuccess: ({
      data: {
        collection
      }
    }) => collection[0]?.atpClusterId
  });
};
exports.getAtpClusterId = getAtpClusterId;
